/** The overline section-label convention, in one place. */
import { Stack, Typography, type SxProps } from "@mui/material";
import type { ReactNode } from "react";

export function SectionLabel({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) {
  return (
    <Typography
      variant="overline"
      color="text.secondary"
      display="block"
      sx={sx}
    >
      {children}
    </Typography>
  );
}

/** A section label with an action on its right (a button, a link). */
export function SectionHeader({
  label,
  action,
  sx,
}: {
  label: ReactNode;
  action?: ReactNode;
  sx?: SxProps;
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      useFlexGap
      spacing={1}
      sx={{ mb: 1, ...(sx as object) }}
    >
      <SectionLabel sx={{ mb: 0 }}>{label}</SectionLabel>
      {action}
    </Stack>
  );
}
